export default "__VITE_ASSET__bc44f444__"